import admin from "./Admin";
import user from "./User";
import searchResult from "./SearchResult";
import searchResponse from "./SearchResponse";
import gcpSearchResponse from "./GcpSearchResponse";
import gtinSearchResponse from "./GtinSearchResponse";

const userDefinedEntities = {
  admin,
  user,
  searchResult,
  searchResponse,
  gtinSearchResponse,
  gcpSearchResponse,
};

const groups = [
  {
    name: { en: "group1", ar: "الجروب" },
    type: "normal",
    entities: [],
  },
  {
    name: "ungrouped",
    entities: [admin, user, searchResult],
  },
];
export { userDefinedEntities, groups };
